import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import ModalAmount from "../car/detailedCar/component/ModalAmount";
import di from "../../../../di/DependencyInjection";
import GetCarByIdUseCase, { GetCarByIdUseCaseName } from "../../../../domain/use_cases/car/GetCarByIdUseCase";
import { routes } from "../../routes/RoutesComponent";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import CarEntity from "../../../../domain/entities/CarEntity";

function CheckoutQrScreen() {
    const [car, setCar] = useState<CarEntity | undefined | null>(undefined);
    const { id } = useParams<{ id: string }>();

    const navigate = useNavigate();

    const _getCar = async () => {
        console.warn(id);
        try {
            const car = await di.get<GetCarByIdUseCase>(GetCarByIdUseCaseName).call(id!);
            console.warn("car.active", car.active);
            if (!car.active) {
                navigate(routes.home.relativePath, {});
                return;
            }
            setCar(car == null ? null : car);
        } catch (error) {
            // navigate(routes.home.relativePath, {});
            setCar(null);
        }
    };

    useEffect(() => {
        _getCar();
    }, []);
    return (
        <Layout>
            <ModalAmount
                id={id}
                close={() => {}}
                carValue={car?.price}
                info={{
                    title: "Separa tu vehículo",
                    paragraph:
                        "Separa tu vehículo pagando hasta el 100% de su valor o con financiacíon hasta de 15 Millones de pesos.",
                    bottonOne: true,
                    bottonTwo: true,
                }}
            />
        </Layout>
    );
}

export default CheckoutQrScreen;
